<style scoped lang="scss">
.effect-lists{
  //display: block!important;
  // justify-content: center;
  flex-wrap:wrap;
  overflow: auto;
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
.cons{
  display: none;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 850px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
  .wrap-compose{
    .c-title1{
      display: block;
    }
    .cons{
      display: none;
    }
    .banner{
      position: relative;
      .info{
        position: absolute;
        top:0;
        width:100%;
        height:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        h1{
          font-size: 46px;
          color:#fff;
        }
      }
      .classify{
        padding:20px;
        background: rgba(255,255,255,.9);
        width: 200px;
        height:300px;
        position: absolute;
        left:calc((100vw - 1200px) / 2);
        top:50%;
        transform: translateY(-50%);
        z-index: 9;
        .title{
          padding-bottom: 10px;
          margin-bottom: 20px;
          font-size: 16px;
          font-weight: bold;
          border-bottom: 1px solid #E4E6EA;
        }
        a{
          color:#333;
          &.active{
            color:#014492;
          }
        }
        li{
          margin-bottom: 20px;
        }
      }
    }
    .map{
      width:940px;
      margin: 0 auto;
    }
    .service{
      background: #F6FAFD;
      ul{
        display: flex;
        justify-content: space-around;
        padding:0 10%;
      }
    }
    .mr41{
      display: block;
    }
    .mr42{
      display: none;
    }
  }
  @media
  screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width:400px)
  {
    .con{
      display: none!important;
    }
    .cons{
      display: block!important;
    }
  }
  @media screen and (max-width: 640px){
    .wrap-compose .map{
      width: 90% !important;
      font-size: 14px!important;
    }
    .c-title1{
      display: none!important;
    }
    .mr42{
      margin-left: auto;
      margin-right: auto;
      display: block!important;
    }
    .mr41{
      display: none!important;
    }
    .container{
      width: 90% !important;
      font-size: 14px!important;
    }
    .wrap-compose .banner .info h1{
      font-size: 25px!important;
    }
  }
</style>
<style lang="scss">
  .wrap-compose{
    .el-tabs--left .el-tabs__header.is-left{
      margin-right: 0;
    }
    .el-tabs--left .el-tabs__item.is-left{
      height:200px;
      background: #F6FAFD;
      border: 2px solid transparent;
      border-right: 2px solid #E4E6EA;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 210px;
      color: #014492;
      font-size: 20px;
      &.is-active{
        background: #fff;
        border: 2px solid #E4E6EA;
        border-right: 2px solid transparent;
      }
      .label{
        display: flex;
        flex-direction: column;
        text-align: center;
        align-items: center;
      }
    }
    .el-tabs__active-bar{
      display: none;
    }
    .el-tabs__content{
      border:2px solid #E4E6EA;
      border-left: 0;
      height:100%;
      padding:30px;
      overflow-y: auto;
      h5{
        margin-bottom: 15px;
        font-size: 18px;
      }
      p{
        margin-bottom: 10px;
      }
    }
  }
</style>

<template>
  <!--  常规引物合成-->
  <div class="wrap wrap-compose">
    <router-view></router-view>
    <div class="container container10">
      <h1>siRNA/miRNA合成</h1>
      <h2 class="mt10">siRNA/miRNA Synthesis</h2>
      <div class="a"><span></span></div>
    </div>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>     
      
      <div class="map">
        <p class="desc">
          RNA干扰（RNA interfering，RNAi）现象是由与靶基因序列同源的双链RNA（double-stranded RNA，dsRNA）引发的广泛存在于生物体内的序列特异性基因转录后的沉默过程。细胞中的核糖核酸酶III家族成员之一的，dsRNA特异性的核酸酶Dicer将dsRNA裂解成由21-25个核苷酸组成的小干扰RNA (small
          interfering RNA，siRNA)，随后siRNA作为介导子引起特异性地降解相同序列的mRNA，从而阻断相应基因表达的转录后基因沉默机制。
        </p>
        <img src="@/assets/images/compose_3_1.png" class="img-fluid con" alt="siRNA/miRNA合成">
        <img src="@/assets/images/compose_3_2.png" class="img-fluid cons" alt="siRNA/miRNA合成">
        
      </div>

      <div class="c-title c-title1">服务类型</div>
      <div class="container con c-title1">
        <el-tabs tab-position="left" style="height: 600px;">
          <el-tab-pane>
            <div slot="label" class="label"><img src="@/assets/images/icon_siRNA.png" alt="擎科生物-RNA合成服务-siRNA合成服务
"> siRNA合成</div>
            <h5>定制siRNA合成</h5>
            <p class="fz16">根据客户提供的序列，化学合成siRNA双链，适合进行各种细胞RNAi实验。保证合成序列的100%正确，不保证序列的干扰效果。合成一般5个工作日完成。</p>
            <el-table
              :data="pageData.RNAtable1"
              :span-method="objectSpanMethod"
              border>
              <el-table-column
                prop="product"
                align="center"
                label="产品">
              </el-table-column>
              <el-table-column
                prop="scale"
                align="center"
                label="规格">
              </el-table-column>
              <!-- <el-table-column
                prop="price"
                align="center"
                label="促销价">
              </el-table-column> -->
            </el-table>
            <p class="fz14 mt10">注：胆固醇修饰的siRNA特别针对难转染的细胞，干细胞，原代细胞。</p>
            <h5 class="mt50">单基因套装 siRNA 设计与合成</h5>
            <p>针对靶基因设计的siRNA的基因沉默效果不尽相同。一般针对靶基因的不同区域设计三对或四对siRNA,保证在标准使用条件下
              （转染效率80%以上）至少一对siRNA的mRNA水平沉默效率达70%以上（保证型套餐仅限于人、小鼠、大鼠的mRNA），
              5-7个工作日交货。</p>
            <el-table
              :data="pageData.RNAtable2"
              :span-method="objectSpanMethod2"
              border>
              <el-table-column
                prop="product"
                align="center"
                label="产品">
              </el-table-column>
              <el-table-column
                prop="intro"
                align="center"
                label="简介">
              </el-table-column>
              <el-table-column
                prop="scale"
                align="center"
                label="规格">
              </el-table-column>
              <!-- <el-table-column
                prop="price"
                align="center"
                label="促销价">
              </el-table-column> -->
            </el-table>
            <h5 class="mt50">普通siRNA合成</h5>
            <el-table
              :data="pageData.RNAtable5"
              :span-method="objectSpanMethod4"
              border>
              <el-table-column
                prop="product"
                align="center"
                label="产品">
              </el-table-column>
              <el-table-column
                prop="scale"
                align="center"
                label="规格">
              </el-table-column>
              <el-table-column
                prop="Purification"
                align="center"
                label="纯度级别">
              </el-table-column>
              <!-- <el-table-column
                prop="price"
                align="center"
                label="目录价">
              </el-table-column> -->
              <el-table-column
                prop="data"
                align="center"
                label="周期">
              </el-table-column>
            </el-table>
            <h5 class="mt50">非荧光修饰siRNA</h5>
            <el-table
              :data="pageData.RNAtable6"
              :span-method="objectSpanMethod"
              border>
              <el-table-column
                prop="product"
                align="center"
                label="产品">
              </el-table-column>
              <el-table-column
                prop="scale"
                align="center"
                label="规格">
              </el-table-column>
              <el-table-column
                prop="Purification"
                align="center"
                label="纯度级别">
              </el-table-column>
              <!-- <el-table-column
                prop="price"
                align="center"
                label="目录价">
              </el-table-column> -->
              <el-table-column
                prop="data"
                align="center"
                label="周期">
              </el-table-column>
            </el-table>
            <h5 class="mt50">荧光标记siRNA</h5>
            <el-table
              :data="pageData.RNAtable7"
              :span-method="objectSpanMethod0"
              border>
              <el-table-column
                prop="product"
                align="center"
                label="产品">
              </el-table-column>
              <el-table-column
                prop="scale"
                align="center"
                label="规格">
              </el-table-column>
              <el-table-column
                prop="Purification"
                align="center"
                label="纯度级别">
              </el-table-column>
              <!-- <el-table-column
                prop="price"
                align="center"
                label="目录价">
              </el-table-column> -->
              <el-table-column
                prop="data"
                align="center"
                label="周期">
              </el-table-column>
            </el-table>
            <h5 class="mt50">siRNA对照品</h5>
            <el-table
              :data="pageData.RNAtable8"
              :span-method="objectSpanMethod0"
              border>
              <el-table-column
                prop="product"
                align="center"
                label="产品">
              </el-table-column>
              <el-table-column
                prop="scale"
                align="center"
                label="规格">
              </el-table-column>
              <el-table-column
                prop="Purification"
                align="center"
                label="纯度级别">
              </el-table-column>
              <!-- <el-table-column
                prop="price"
                align="center"
                label="目录价">
              </el-table-column> -->
              <el-table-column
                prop="data"
                align="center"
                label="周期">
              </el-table-column>
            </el-table>
            <h5 class="mt50">注意：siRNA在体内会被快速降解，如需进行动物实验，建议对RNA进行必要的修饰。</h5>
          </el-tab-pane>
          <el-tab-pane label="Config">
            <div slot="label" class="label"><img src="@/assets/images/icon_miRNA.png" alt="擎科生物-RNA合成服务-miRNA合成服务
"> miRNA合成</div>
            <h5>miRNA合成</h5>
            <el-table
              :data="pageData.RNAtable3"
              border>
              <el-table-column
                prop="product"
                align="center"
                label="产品">
              </el-table-column>
              <el-table-column
                prop="scale"
                align="center"
                label="规格">
              </el-table-column>
              <!-- <el-table-column
                prop="price"
                align="center"
                label="促销价">
              </el-table-column>
              <el-table-column
                align="center"
                label="修饰价格">
                <template><span>详询</span></template>
              </el-table-column> -->
            </el-table>
            <h5 class="mt50">miRNA相关产品</h5>
            <el-table
              :data="pageData.RNAtable9"
              border>
              <el-table-column
                prop="product"
                align="center"
                label="产品">
              </el-table-column>
              <el-table-column
                prop="scale"
                align="center"
                label="规格">
              </el-table-column>
              <el-table-column
                prop="Purification"
                align="center"
                label="纯度级别">
              </el-table-column>
              <!-- <el-table-column
                prop="price"
                align="center"
                label="价格">
              </el-table-column> -->
              <el-table-column
                prop="data"
                align="center"
                label="周期">
              </el-table-column>
            </el-table>
            <p class="desc mt20">注意：mRNA性质不稳定，如需进行动物实验，请订购agomir/antagomir。</p>
            <p class="desc mt20">Agomir和Antagomir是根据成熟体miRNA设计的调控miRNA表达量工具，相对于miRNA mimics/inhibitor，该工具增加了多种修饰，大大提高了转染效率和稳定性。效果持续时间至少达到一周，最长可达5-6周。</p>
            <img src="@/assets/images/RNA1.png">
            <p style="overflow:auto;"><img src="@/assets/images/RNA_1.png" style="float: left;"><span style="display: block;margin-top: 3px;margin-left: 24px;">：2’甲氧基修饰，增强抗核酸酶能力，且可以提高对碱基的的亲和力。</span></p>
            <p style="overflow:auto;"><img src="@/assets/images/RNA_2.png" style="float: left;"><span style="display: block;margin-top: 3px;margin-left: 24px;">：硫代磷酸化修饰，增强核酸酶抗性，动物实验中，半衰期从几分钟增加到了几天。</span></p>
            <p style="overflow:auto;"><img src="@/assets/images/RNA_3.png" style="float: left;"><span style="display: block;margin-top: 3px;margin-left: 24px;">：胆固醇修饰，提高和细胞膜的亲和力，从而提高转染效率。</span></p>
          </el-tab-pane>
<!--          <el-tab-pane label="Role">-->
<!--            <div slot="label" class="label"><img src="@/assets/images/icon_RNA.png" alt="擎科生物-RNA合成服务-环状RNA引物设计和验证服务"> 环状RNA引物设计<br>和验证</div>-->
<!--            <h5>环状RNA引物设计和验证</h5>-->
<!--            <el-table-->
<!--              :data="pageData.RNAtable4"-->
<!--              :show-header="false"-->
<!--              :span-method="objectSpanMethod3"-->
<!--              border>-->
<!--              <el-table-column-->
<!--                prop="product"-->
<!--                class-name="bg"-->
<!--                width="232px"-->
<!--                align="center"-->
<!--                label="产品">-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                prop="type"-->
<!--                align="center"-->
<!--                label="规格">-->
<!--              </el-table-column>-->
<!--            </el-table>-->
<!--          </el-tab-pane>-->
        </el-tabs>
      </div>
      <div class="c-title">资源中心<small>Resource center</small></div>
      <div class="container mt30 mb30">
        <ul class="download">
          <li v-for="item in resourcesLists" :key="item.id">
            {{item.name}}
            <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
          </li>
        </ul>
      </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <div class="container con">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer" :class="{active1: currentService === index}" @mouseover="currentService = index" @mouseout="currentService = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/gr_${item.img}${currentService===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class="effect-lists1 effect-lists" style="display: flex!important; justify-content: center!important;">
            <li v-for="(item, index) in types1" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/img/gr_${item.img}${currentService===index ? '' : ''}.png`" style="width: 50px;height: 55px;">
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
            </li>
          </ul>
        </div>
      </div>
    <div class="container">
        <qk-consult type="Virus"/>
    </div>
  </div>
</template>

<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import { mapState } from 'vuex'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data() {
    return {
      resourcesLists: [],
      types1: [
        {name: 'shRNA慢病毒质粒构建', img: '1', ref: '/products/shRNA_lentiviral'},
        {name: 'shRNA文库构建', img: '2', ref: '/products/shRNA_library_construction'},
      ],
      currentService:-1,
    }
  },
  computed: {
    ...mapState(['pageData'])
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    objectSpanMethod0 ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 1,
            colspan: 1
          }
        } else {
          return {
            rowspan: 1,
            colspan: 1
          }
        }
      }
    },
    objectSpanMethod2 ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 3) {
        if (rowIndex === 0 || rowIndex === 4) {
          return {
            rowspan: 4,
            colspan: 1
          }
        } else if (rowIndex === 8) {
          return {
            rowspan: 3,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    objectSpanMethod3 ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: 7,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    objectSpanMethod4 ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: 10,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    handleJumpPath(path) {
      let queryPath = ''
      if(this.$route.path === '/tec/compose1') {
        queryPath = 'product=true'
      }
      Object.entries(this.$route.query).forEach(([key, value = '']) => {
        queryPath += `${key}=${value}`
      })
      return `${path}?${queryPath}`
    },
     // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/siRNA_miRNA_synthesis.vue